// extracted by mini-css-extract-plugin
export default {"cls1":"VeloButton-StyledButton_cls1__ftpyn","cls2":"VeloButton-StyledButton_cls2__B6YzV VeloButton-StyledButton_cls1__ftpyn","fullWidth":"VeloButton-StyledButton_fullWidth__HanKs"};